var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("el-input", {
        class: { require: _vm.getRequire && _vm.isNull(), item: true },
        attrs: {
          type: "text",
          size: "small",
          placeholder: "请输入内容",
          disabled: _vm.disabled,
          "show-word-limit": "",
          clearable: true,
        },
        on: { input: _vm.input, focus: _vm.togglePopover },
        model: {
          value: _vm.val,
          callback: function ($$v) {
            _vm.val = $$v
          },
          expression: "val",
        },
      }),
      _c(
        "el-dialog",
        {
          staticClass: "ik-el-popover-warp",
          attrs: { visible: _vm.visible, placement: "bottom", width: "800" },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
          },
        },
        [
          _c("el-input", {
            class: { require: _vm.getRequire && _vm.isNull(), item: true },
            attrs: {
              type: "text",
              size: "small",
              placeholder: "请输入内容",
              disabled: _vm.disabled,
              "show-word-limit": "",
              clearable: true,
            },
            on: { input: _vm.input, focus: _vm.togglePopover },
            model: {
              value: _vm.val,
              callback: function ($$v) {
                _vm.val = $$v
              },
              expression: "val",
            },
          }),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              attrs: { data: _vm.tableData },
              on: { "row-click": _vm.rowClick },
            },
            [
              _vm._l(_vm.filedList, function (item, index) {
                return [
                  item.type === "select"
                    ? _c("table-select-item", {
                        key: index,
                        attrs: {
                          code: item.code,
                          "key-field": "key",
                          "value-field": "value",
                          name: item.name,
                          options: item.config.options,
                          width: "120",
                          edit: false,
                        },
                      })
                    : _c(
                        "el-table-column",
                        _vm._b(
                          {
                            key: index,
                            attrs: { property: item.code, label: item.name },
                          },
                          "el-table-column",
                          item.config,
                          false
                        )
                      ),
                ]
              }),
            ],
            2
          ),
          _c("el-pagination", {
            attrs: {
              layout: "total, prev, pager, next",
              "page-count": _vm.pagination.pageCount,
              "page-size": _vm.pagination.pageSize,
              total: _vm.pagination.totalCount,
            },
            on: {
              "current-change": _vm.currentChange,
              "prev-click": _vm.prevClick,
              "next-click": _vm.nextClick,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }